import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    logoLink: {
        transition: 'all 0.5s',
        height: '70%',
        display: 'flex',
        alignItems: 'center'
    },
    logo: {
        transition: 'all 0.5s',
        height: '100%'
    },
    logoTitle: {
        transition: 'all 0.5s',
        height: '80%'
    }
}))

export default useStyles
